export const GET_DASHBOARD_REQUEST = 'dashboard/GET_DASHBOARD_REQUEST'
export const DASHBOARD_PAGE_REQUEST = 'DASHBOARD_PAGE_REQUEST'
export const SET_DASHBOARD = 'SET_DASHBOARD'
export const DASHBOARD_CHANGE_OUTLET = 'DASHBOARD_CHANGE_OUTLET'
export const DASHBOARD_CHANGE_DATE = 'DASHBOARD_CHANGE_DATE'
export const DASHBOARD_SET_OUTLETS = 'DASHBOARD_SET_OUTLETS'
/* --- dashboard async --- */
export const DASHBOARD_SET_ASYNC_FLAG = 'DASHBOARD_SET_ASYNC_FLAG'
export const DASHBOARD_SET_FILTER_DATA_ASYNC = 'DASHBOARD_SET_FILTER_DATA_ASYNC'
export const DASHBOARD_GET_DATA_URL_ASYNC = 'DASHBOARD_GET_DATA_URL_ASYNC'
export const DASHBOARD_SET_FLAG_ERROR_PUSHER_DASHBOARD = 'DASHBOARD_SET_FLAG_ERROR_PUSHER_DASHBOARD'



// WEBPACK FOOTER //
// ./app/actions/dashboard/constants.js